<rt-dropdown [width]="DropdownWidth.FullWidth">
  <div class="content padding-right-small-x">
    <rt-button size="small" variant="plain" (click)="edit()">{{
      'wysiwyg.edit' | translate
    }}</rt-button>
    <div class="separator"></div>
    <rt-button size="small" variant="plain" (click)="resetSize()">{{
      'wysiwyg.reset_size' | translate
    }}</rt-button>
    <div class="separator"></div>
    <rt-button size="small" variant="plain" (click)="delete()">{{
      'wysiwyg.delete' | translate
    }}</rt-button>
    <div class="separator"></div>
    <rt-button
      #alignDropdownTrigger="rtOverlayOrigin"
      (click)="alignDropdown.open = !alignDropdown.open"
      [dropdownOpened]="alignDropdown.open"
      [rtTooltip]="'wysiwyg.align' | translate"
      rt-overlay-origin
      size="small"
      variant="plain"
      class="pm-icon-dropdown-trigger"
    >
      <rt-icon prefix size="small" [name]="alignIcon" />
    </rt-button>
  </div>
</rt-dropdown>

<ng-template
  #alignDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [open]="alignDropdown.open"
  [origin]="alignDropdownTrigger"
  (backdropClick)="alignDropdown.open = false"
>
  <rt-dropdown [width]="DropdownWidth.FullWidth">
    <div class="content">
      <rt-icon-button
        [pressed]="align === 'left'"
        size="small"
        variant="plain"
        [iconName]="'art-track'"
        [rtTooltip]="'wysiwyg.left' | translate"
        (click)="$event.stopPropagation(); setAlign('left')"
      />
      <rt-icon-button
        size="small"
        variant="plain"
        [pressed]="align === 'center'"
        [iconName]="'image-align-center'"
        [rtTooltip]="'wysiwyg.center' | translate"
        (click)="$event.stopPropagation(); setAlign('center')"
      />
      <rt-icon-button
        size="small"
        variant="plain"
        [pressed]="align === 'right'"
        [iconName]="'burst-mode'"
        [rtTooltip]="'wysiwyg.right' | translate"
        (click)="$event.stopPropagation(); setAlign('right')"
      />
    </div>
  </rt-dropdown>
</ng-template>
